export const initialState = {
  confirmSMSCodeFetch: false,
  inputWarning: null,
  timerStartTime: 0,
  isViewResendButton: false,
  otpId: null,
  fetchError: false,
  teleponyConfirm: {
    isViewResendButton: false,
    isViewTryoutButton: false,
    isViewTimeoutButton: false,
    timerStartTime: 0,
    awaitingState: true,
    wrongCodeState: false,
    globalTimeoutState: false,
    totalResendTries: 0,
    currentResendTries: 0,
    isConfirmed: false,
    isFetching: false,
  },
};
